export { __modelMeta__ } from '@aws-amplify/data-schema-types';
export { addSchemaToClient } from './addSchemaToClient.mjs';
export { addSchemaToClientWithInstance } from './addSchemaToClientWithInstance.mjs';
export { INTERNAL_USER_AGENT_OVERRIDE } from './internals/ai/getCustomUserAgentDetails.mjs';
//# sourceMappingURL=index.mjs.map
